import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Tag, Check, Eraser } from "lucide-react";
import { customLabel } from "@/lib/labels";

export default function RenameModal({ device, labels, onClose, onSave }) {
  const [text, setText] = useState("");

  useEffect(() => {
    if (device) setText(customLabel(device, labels) || "");
  }, [device, labels]);

  return (
    <AnimatePresence>
      {device && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 z-40 bg-black/20 backdrop-blur-[2px]"
          />
          <motion.div
            initial={{ scale: 0.94, opacity: 0, y: 10 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.94, opacity: 0, y: 10 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            dir="rtl"
            className="absolute left-1/2 top-1/2 z-50 w-[380px] max-w-[calc(100vw-2rem)] -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-white/60 bg-white/95 p-5 shadow-2xl backdrop-blur-xl"
            data-testid="rename-modal"
          >
            <div className="mb-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Tag size={17} className="text-[#0055FF]" />
                <h2 className="text-[15px] font-bold text-[#0A0A0A]">שם מותאם למכשיר</h2>
              </div>
              <button
                onClick={onClose}
                className="rounded-lg p-1 text-[#52525B] transition-colors hover:bg-black/5"
              >
                <X size={18} />
              </button>
            </div>

            <p className="mb-1 font-mono text-[12px] text-[#52525B]" dir="ltr">
              {device.ip}
              {device.mac ? ` · ${device.mac}` : ""}
            </p>

            <input
              data-testid="rename-input"
              value={text}
              onChange={(e) => setText(e.target.value)}
              autoFocus
              placeholder="לדוגמה: המחשב של דוד / טלוויזיה בסלון"
              onKeyDown={(e) => {
                if (e.key === "Enter") onSave(device, text.trim());
              }}
              className="mt-2 w-full rounded-xl border border-black/10 bg-white px-3 py-2.5 text-[14px] text-[#0A0A0A] outline-none focus:border-[#0055FF] focus:ring-2 focus:ring-[#0055FF]/20"
            />

            <div className="mt-5 flex justify-between gap-2">
              <button
                data-testid="rename-clear"
                onClick={() => onSave(device, "")}
                className="flex items-center gap-1.5 rounded-xl px-3 py-2 text-[13px] font-semibold text-[#52525B] transition-colors hover:bg-black/5"
              >
                <Eraser size={14} />
                נקה שם
              </button>
              <button
                data-testid="rename-save"
                onClick={() => onSave(device, text.trim())}
                className="flex items-center gap-2 rounded-xl bg-[#0055FF] px-5 py-2 text-[13px] font-semibold text-white shadow-md transition-colors hover:bg-[#0047d6]"
              >
                <Check size={15} />
                שמור
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
